import { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

export function useRouter() {
  const navigate = useNavigate();
  const location = useLocation();

  const router = useMemo(
    () => {
      const searchParams = new URLSearchParams(location.search);
      const query: Record<string, string> = {};

      // Convertir les paramètres d'URL en objet query sans utiliser for...of
      Array.from(searchParams.entries()).forEach(([key, value]) => {
        query[key] = value;
      });

      return {
        back: () => navigate(-1),
        forward: () => navigate(1),
        reload: () => window.location.reload(),
        push: (href: string) => navigate(href),
        replace: (href: string) => navigate(href, { replace: true }),
        query,
      };
    },
    [navigate, location.search]
  );

  return router;
}
